import { AuthModalSteps } from "./AuthModal"
import SignUpForm from "components/page_components/auth/User/Signup/signupForm/signupForm"

interface SignupProps {
    onSwitchToLogin: () => void
    setStep: (step: string | AuthModalSteps | any) => string | AuthModalSteps | any
    setAuthData: (data: any) => void
    setAuthMode: (mode: "login" | "signup") => void
}

const AuthModalSignup = ({
    onSwitchToLogin,
    setStep,
    setAuthData,
    setAuthMode,
}: SignupProps) => {
    return (<SignUpForm

        onSwitchToLogin={onSwitchToLogin}
        setStep={setStep}
        setAuthData={setAuthData}
        setAuthMode={setAuthMode}

    />)


}

export default AuthModalSignup
